import { Box } from "@repo/components/src/ui/box";
import React from "react";

type Props = {
  /** Pixel offset for SVG charts, or a `%` string for CSS-width bars (small multiples). */
  left: number | string;
  top: number | string;
  content: React.ReactNode;
};

/**
 * Absolutely-positioned tooltip, meant to be rendered as the last child of a
 * `relative` chart wrapper — the caller computes `left`/`top` from the
 * hovered slot/bar and clamps them to the chart's bounds.
 */
const ChartTooltip = ({ left, top, content }: Props) => {
  return (
    <Box
      pointerEvents="none"
      className="absolute z-10 rounded-lg border border-outline-100 bg-background-0 px-2.5 py-2 shadow-soft-1 text-[12px] text-typography-900"
      style={{ left, top } as object}
    >
      {content}
    </Box>
  );
};

export default ChartTooltip;
